import React from 'react';
import styles from './FieldLabel.module.scss';
import { FieldType } from '@/services/formSchema.service';

interface IFieldLabel {
    label: string;
    fieldType: string;
}

export const FieldLabel: React.FC<IFieldLabel> = ({ label, fieldType }) => {
    if (fieldType === FieldType.CHECKBOX) {
        return null;
    }

    return <div className={styles.label}>{label}</div>;
};
